import { Reducer } from 'redux';

import { IErrorActionData } from '../../../models/Error';
import { GetRecommendationTaskSummaryActionTypes, GetRecommendationTaskSummaryActions } from '../actions/GetRecommendationTaskSummary';
import { IRecommendationTaskDetails, RecommendationTaskSummaryDetails } from '../models/GetRecommendationTaskSummary';

export interface IRecommendationTaskSummaryState {
  recommendationTaskSummaryDetails: RecommendationTaskSummaryDetails;
  isProcessing: boolean;
  isSuccess: boolean;
  error?: IErrorActionData;
}

const initialRecommendationTaskSummaryState = {
  recommendationTaskSummaryDetails: new RecommendationTaskSummaryDetails({} as IRecommendationTaskDetails),
  isProcessing: false,
  isSuccess: false,
  error: undefined,
} as IRecommendationTaskSummaryState;

const GetRecommendationTaskSummaryReducer: Reducer<IRecommendationTaskSummaryState, GetRecommendationTaskSummaryActions> = (
  state = initialRecommendationTaskSummaryState,
  action: GetRecommendationTaskSummaryActions,
): IRecommendationTaskSummaryState => {
  switch (action.type) {
    case GetRecommendationTaskSummaryActionTypes.GET_RECOMMENDATION_TASK_SUMMARY:
      return {
        ...state,
        isProcessing: true,
        isSuccess: false,
        error: undefined,
      };

    case GetRecommendationTaskSummaryActionTypes.GET_RECOMMENDATION_TASK_SUMMARY_SUCCESS: {
      return {
        ...state,
        recommendationTaskSummaryDetails: new RecommendationTaskSummaryDetails(action.payload.data),
        isProcessing: false,
        isSuccess: true,
        error: undefined,
      };
    }

    case GetRecommendationTaskSummaryActionTypes.GET_RECOMMENDATION_TASK_SUMMARY_FAILED:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        error: {
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
          callBack: action.payload.callBack,
        },
      };

    case GetRecommendationTaskSummaryActionTypes.GET_RECOMMENDATION_TASK_SUMMARY_RESET:
      return initialRecommendationTaskSummaryState;

    default:
      return state;
  }
};

export default GetRecommendationTaskSummaryReducer;
